<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.type_profile_id != null}">
                                        <label for="type_profiles" class="bmd-label-floating">Tipos de Perfil</label>
                                        <multi-select
                                            v-model="form.type_profile_id"
                                            placeholder="Selecione o Tipo de Perfil"
                                            label="name"
                                            track-by="name"
                                            value="id"
                                            :options="type_profiles"
                                            :multiple="false"
                                            :preserve-search="true"
                                            @input="handlerChangeProfile">
                                        </multi-select>
                                        <label v-if="validation.type_profile_id != null" id="type_profile_id-error" class="error" for="type_profile_id">{{ validation.type_profile_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                    v-if="form.type_profile_id != null">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.user_id != null}">
                                        <label for="users" class="bmd-label-floating">{{ form.type_profile_id.name }}</label>
                                        <multi-select
                                            v-model="form.user_id"
                                            :placeholder="'Selecione o ' + form.type_profile_id.name"
                                            label="name"
                                            track-by="name"
                                            value="id"
                                            :options="users"
                                            :multiple="false"
                                            :preserve-search="true">
                                        </multi-select>
                                        <label v-if="validation.user_id != null" id="user_id-error" class="error" for="user_id">{{ validation.user_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_by != null}">
                                        <label for="type_filter_date" class="bmd-label-floating">Filtar data por</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="dates"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.date_by">
                                        </model-list-select>
                                        <label v-if="validation.date_by != null" id="date_by-error" class="error" for="date_by">{{ validation.date_by }}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            >
                                        </date-picker>
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.branch_id != null}">
                                        <label for="branch_id" class="bmd-label-floating">Loja</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="branches"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Loja"
                                            v-model="form.branch_id">
                                        </model-list-select>
                                        <label v-if="validation.branch_id != null" id="branch_id-error" class="error" for="branch_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.administrator_id != null}">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="administrators"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Administradora"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != null" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Users from '@/services/modules/users.service';
    export default {
        computed: {
            administrators() {
                return this.$store.state.administrators.itens;
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            dates() {
                var dates = [
                    {id: 'sale_at', name: 'Data de Venda'},
                    {id: 'pay_at', name: 'Data de Pagamento'}
                ];

                return dates;
            },
        },
        data() {
            return {
                form: {
                    administrator_id: null,
                    branch_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    date_by: "pay_at",
                    user_id: null,
                    type_profile_id: null
                },
                type_profiles: [],
                users: [],
                validation: {
                    administrator_id: null,
                    branch_id: null,
                    date_at: null,
                    date_by: null,
                    user_id: null,
                    type_profile_id: null
                }
            };
        },
        methods: {
            async getDataAdministrators() {
                var self = this;
                self.$root.$emit("onLoading");
                const response = self.$store.dispatch('administrators/all');
                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataProfiles();
                });
                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataProfiles();
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = TypeProfiles.all();

                response.then(function (_profiles) {
                    self.type_profiles = _profiles.filter(profile => profile.id !== 1);
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            handlerChangeProfile(typeProfile) {
                var self = this;
                self.users = [];

                if (typeProfile != null && typeProfile.id != "") {
                    const search = {
                        params: {
                            type_profile_id: typeProfile.id
                        }
                    }
                    const promise = Users.all(search)

                    promise.then((users) => {
                        self.users = users
                    })

                    promise.catch((error) => {
                        console.log(error)
                    })
                }
            },
            onReset() {
                this.form = {
                    administrator_id : null,
                    branche_id: null,
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    date_at: null,
                };

                if (!self.form.date_at[0] || !self.form.date_at[1]) {
                    valid = false;
                    self.validation.date_at = 'Favor informar o intervalo desejado!';
                }

                if (self.form.type_profile_id == null) {
                    valid = false;
                    self.validation.type_profile_id = "Favor informar o tipo do perfil desejado!";
                }

                if (self.form.date_by == "") {
                    valid = false;
                    self.validation.date_by = "Favor informar o tipo de datas desejado!";
                }
                if (valid) {
                    var dataToSend = {
                        administrator_id: self.form.administrator_id,
                        branch_id: self.form.branch_id,
                        date_at: self.form.date_at,
                        date_by: self.form.date_by,
                        type_profile_id: self.form.type_profile_id.id,
                        user_id: self.form.user_id
                    }
                    var serialize = JSON.stringify(dataToSend);
                    window.open("print-type-sales?form=" + serialize, '_blank');
                }
            },
        },
        created() {
            var self = this;
            self.getDataAdministrators();
        }
    }
</script>
